<button #button
(click)="clicked ($event)"
class="btn btn-primary "
[ngClass]="buttonClass"
[disabled]="disabled"
>{{ getText() }}</button>